import React, { useState } from "react";
import { ReactComponent as CloseIcon } from "../../../Assets/Icons/popupCloseIcon.svg";
import { ReactComponent as Bullet } from "../../../Assets/Icons/FundraiserIcon.svg";
import { ReactComponent as Minus } from "../../../Assets/Icons/minusButton.svg";
import { useDispatch } from "react-redux";
import { removeFundraiserFromPromotion } from "../../../services/assetsService";
import { toast } from "react-toastify";
import "../../common/common.scss";

const FundraiserPopup = ({
  fundraisers: initialFundraisers,
  handleCloseFundraiser,
  promotionId,
  onFundraiserRemoved,
}) => {
  const dispatch = useDispatch();
  const [fundraisers, setFundraisers] = useState(initialFundraisers);

  const handleRemoveFundraiser = async (fundraiserId) => {
    try {
      const response = await dispatch(
        removeFundraiserFromPromotion({
          promotionId: promotionId,
          fundraiserId: fundraiserId,
        })
      ).unwrap();

      if (response?.success) {
        // Remove fundraiser from local state
        setFundraisers((prevFundraisers) =>
          prevFundraisers.filter((f) => f._id !== fundraiserId)
        );

        // Show success toast
        toast.success("Fundraiser removed successfully", {
          style: {
            background: "#E6F7FB",
            color: "#007EA7",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
            padding: "12px 16px",
          },
          progressStyle: {
            background: "#007EA7",
          },
          icon: "✅",
        });

        // Trigger parent refresh
        onFundraiserRemoved();
      }
    } catch (error) {
      console.error("Error removing fundraiser:", error);
      toast.error(
        error?.response?.data?.message || "Failed to remove fundraiser"
      );
    }
  };

  return (
    <div className="popup-container">
      <div
        className={`popup flex flex-col justify-evenly items-center sm:w-[470px] bg-white rounded-[10px] drop-shadow-[0_3px_3px_rgba(0,0,0,0.25)] relative pt-5 ${
          fundraisers.length > 3 ? "pb-8 h-[500px] overflow-y-scroll" : "pb-8"
        }`}
      >
        <div className="h-[3%]">
          <CloseIcon
            className="absolute top-5 right-5 cursor-pointer"
            onClick={handleCloseFundraiser}
          />
        </div>
        <div className="h-[92%] w-full flex flex-col justify-start gap-4">
          <span className="font-poppins font-[500] text-[18px] text-left pl-5">
            Fundraisers
          </span>
          <ul
            className={`flex flex-col gap-2 w-[100%] px-5 ${
              fundraisers.length > 3 ? "overflow-y-scroll" : ""
            }`}
          >
        {fundraisers?.map((f, index) => (
              <div
                key={f?._id}
                className={`flex justify-center items-center w-[100%] gap-4 rounded-[10px] bg-white shadow-[0_4px_10px_0px_rgba(0,0,0,0.1)] py-5 px-2`}
              >
                <Bullet className="w-[10%]" />
                <li className="w-[90%] font-poppins font-[400] text-[14px] text-[#303030] pr-1">
                  {f?.user?.name}
                </li>
            {fundraisers?.length > 1 && (
              <Minus
                className="cursor-pointer"
                onClick={() => handleRemoveFundraiser(f?._id)}
              />
            )}
              </div>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default FundraiserPopup;
